import { CSSObject } from '@emotion/react'

type DisplayProps = {
  [key: string]: number
}

const renderDisplayLayout: DisplayProps = {
  desktopSingle: 600,
  mobileSingle: 430,
}

const baseStyles = (display: string): CSSObject => ({
  backgroundColor: '#fff',
  border: 'none',
  borderRadius: 0,
  display: 'flex',
  flexDirection: 'column',
  padding: '20px 10px 20px 10px',
  width: renderDisplayLayout[display],
})

export { baseStyles }
